<script setup>
import BroadcastTemplateForm from '@/components/crm/BroadcastTemplateForm.vue'
import { useApi } from '@/utils/api'
import { useApiRequest } from '@/composables/useApiRequest'

definePage({
  meta: {
    layout: 'default',
    action: 'create',
    subject: 'Broadcast',
  },
})

const router = useRouter()
const { loading, errors, request } = useApiRequest()

const form = ref({
  name: '',
  channel: 'whatsapp',
  subject: '',
  body_template: '',
  type: 'custom',
  is_active: true,
})

const submit = async () => {
  const result = await request(() =>
    useApi('/api/v1/broadcast-templates').post({ body: form.value }),
  )

  if (result !== null) {
    router.push({ name: 'crm-broadcast-templates' })
  }
}
</script>

<template>
  <VRow>
    <VCol cols="12">
      <VCard>
        <VCardTitle class="pt-5 px-5">
          Tambah Template Broadcast
        </VCardTitle>

        <VDivider />

        <VCardText class="pa-5">
          <VAlert
            v-if="errors._general"
            type="error"
            variant="tonal"
            class="mb-4"
          >
            {{ errors._general[0] }}
          </VAlert>

          <BroadcastTemplateForm
            v-model="form"
            :errors="errors"
          />
        </VCardText>

        <VDivider />

        <VCardActions class="pa-5">
          <VSpacer />
          <VBtn
            variant="tonal"
            :to="{ name: 'crm-broadcast-templates' }"
          >
            Batal
          </VBtn>
          <VBtn
            color="primary"
            :loading="loading"
            @click="submit"
          >
            Simpan
          </VBtn>
        </VCardActions>
      </VCard>
    </VCol>
  </VRow>
</template>
